export default __webpack_public_path__ + "static/media/Padron_1964.8ec92e8f.jpg";